import { connect } from 'react-redux'
import PupilsSearch from './pupils-search'
import { getSearchValue } from '../pupils-component-redux/pupils-component.selectors'
import { searchValueChange } from '../pupils-component-redux/pupils-component.actions'
import debounce from 'lodash/debounce'

const mapStateToProps = state => ({
  searchValue: getSearchValue(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  searchValueChange: debounce(value => dispatch(searchValueChange(value)), 300)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PupilsSearch)
